/* export const myMutation = (state)=> {} */

export const statesAccount = (state, payload) => {
    state.statesAccount.search = {
        ...state.statesAccount.search,
        ...payload
    };
}

export const paymentsHistory = (state, payload) => {
    state.paymentsHistory.search = {
        ...state.paymentsHistory.search,
        ...payload
    };
}

export const modalInfoBehavior = (state, payload) => {
    state.paymentsHistory.modals.infoBehavior = payload;
}

export const historyScore = (state, payload) => {
    state.paymentsHistory.score = payload;
}

export const cashBilling = (state, payload) => {
    state.cashBilling.search = {
        ...state.cashBilling.search,
        ...payload
    };
}

export const cashBillingNotice = (state, payload) => {
    state.cashBilling.search.notice = {
        ...state.cashBilling.search.notice,
        ...payload
    };
}

export const cashContacts = (state, payload) => {
    state.cashContacts = {
        ...state.cashContacts,
        ...payload
    };
}

export const cashContactsForm = (state, payload) => {
    state.cashContacts.form = {
        ...state.cashContacts.form,
        ...payload
    };
}

export const cashBillingSend = (state, payload) => {
    state.cashBilling.search.send = {
        ...state.cashBilling.search.send,
        ...payload
    };
}


